import { render, staticRenderFns } from "./Home.pid-bank-lists-details.vue?vue&type=template&id=b6b34126&scoped=true&"
import script from "./Home.pid-bank-lists-details.vue?vue&type=script&lang=js&"
export * from "./Home.pid-bank-lists-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b34126",
  null
  
)

export default component.exports